import { loanApplicationTagsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { selectMasterCompanyId } from 'store/auth/selectors';

export const LOAN_APPLICATION_TAGS_ACTION_TYPE = createNamedActions('loanApplicationTags', {
  GET_TAGS: 'GET_TAGS',
});

export const getLoanApplicationTagsAction = catchAsyncActionError(
  () => async (dispatch, getState) => {
    const companyId = selectMasterCompanyId(getState());

    const { data } = await loanApplicationTagsApi.getLoanTags({
      companyId,
      includeGlobal: true,
      includeDeleted: false,
    });

    return dispatch({
      type: LOAN_APPLICATION_TAGS_ACTION_TYPE.GET_TAGS,
      payload: data,
    });
  },
);
